import { useRouter } from "vue-router/composables";
export function buildInstanceRoutingComposable(index) {
    return () => {
        const router = useRouter();
        async function goToIndex(query) {
            router.push({
                path: index,
                query: query,
            });
        }
        return {
            goToIndex,
        };
    };
}
